<template>
  <b-modal
    :visible="show"
    :title="titulo"
    size="xl"
    centered
    hide-footer
    @hidden="$emit('close')"
  >
    <b-form @submit.prevent="salvar">
      <b-row>
        <b-col md="8">
          <b-form-group label="Nome da rotina">
            <b-form-input
              v-model.trim="form.nome"
              :state="state('nome')"
              placeholder="Envio mensal ao contador"
            />
            <b-form-invalid-feedback>{{ errors.nome }}</b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col md="3">
          <b-form-group label="Status">
            <b-form-checkbox v-model="form.ativo" switch>
              Ativo
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="4">
          <EmailListInput
            v-model="form.emails"
            label="Destinatários"
            :error="errors.emails"
          />
        </b-col>
        <b-col md="4">
          <EmailListInput
            v-model="form.cc"
            label="Cópia"
            placeholder="financeiro@example.com"
            :error="errors.cc"
          />
        </b-col>
        <b-col md="4">
          <EmailListInput
            v-model="form.bcc"
            label="Cópia oculta"
            placeholder="gestao@example.com"
            :error="errors.bcc"
          />
        </b-col>
      </b-row>

      <b-row class="mt-4">
        <b-col md="3">
          <b-form-group label="Dia do mês">
            <b-form-input
              v-model.number="form.dia_mes"
              type="number"
              min="1"
              max="31"
              :state="state('dia_mes')"
            />
            <b-form-invalid-feedback>
              {{ errors.dia_mes }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="Período">
            <b-form-select
              v-model="form.periodo"
              :options="periodoOptions"
              :state="state('periodo')"
            />
            <b-form-invalid-feedback>
              {{ errors.periodo }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col md="4">
          <b-form-group label="Rotina automática">
            <div class="form-control-plaintext text-muted">
              Geração entre 00:00 e 06:00. Envio às 07:00.
            </div>
          </b-form-group>
        </b-col>

        <b-col md="2">
          <b-form-group label="Sem movimento">
            <b-form-checkbox v-model="form.enviar_sem_movimento" switch>
              Enviar mesmo sem movimento
            </b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col md="6">
          <b-form-group label="Assunto do e-mail">
            <b-form-input
              v-model.trim="form.assunto_email"
              placeholder="Arquivos contábeis da competência"
            />
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Mensagem do e-mail">
            <b-form-textarea
              v-model.trim="form.mensagem_email"
              rows="2"
              placeholder="Segue link para download do Pacote ZIP."
            />
          </b-form-group>
        </b-col>
      </b-row>

      <b-form-group label="Itens para envio">
        <ItensEnvioChecklist
          v-model="form.itens"
          :itens="itens"
          :error="errors.itens"
        />
      </b-form-group>

      <b-row v-if="spedFiscalSelecionado" class="mt-3">
        <b-col md="4">
          <b-form-group label="Perfil do SPED Fiscal">
            <b-form-select
              v-model="form.perfil_sped"
              :options="perfilSpedOptions"
              :state="state('perfil_sped')"
            />
            <b-form-invalid-feedback>
              {{ errors.perfil_sped }}
            </b-form-invalid-feedback>
            <small class="text-muted">
              Perfil informado no registro 0000 do arquivo SPED.
            </small>
          </b-form-group>
        </b-col>
      </b-row>

      <div class="d-flex justify-content-end mt-5">
        <button type="button" class="btn btn-light mr-2" @click="$emit('close')">
          Cancelar
        </button>
        <button type="submit" class="btn btn-primary" :disabled="saving">
          <span v-if="saving" class="spinner-border spinner-border-sm mr-2"></span>
          Salvar configuração
        </button>
      </div>
    </b-form>
  </b-modal>
</template>

<script>
import EmailListInput from "./EmailListInput.vue";
import ItensEnvioChecklist from "./ItensEnvioChecklist.vue";
import {
  ENVIO_CONTABILIDADE_DEFAULT_FORM,
  ENVIO_CONTABILIDADE_PERIODO_LABELS,
} from "@/modules/envio-contabilidade/utils";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: "EnvioContabilidadeConfigFormModal",
  components: {
    EmailListInput,
    ItensEnvioChecklist,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Object,
      default: null,
    },
    itens: {
      type: Array,
      default: () => [],
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: this.novoForm(),
      errors: {},
    };
  },
  computed: {
    titulo() {
      return this.value && this.value.id
        ? "Editar configuração"
        : "Nova configuração";
    },
    periodoOptions() {
      return Object.keys(ENVIO_CONTABILIDADE_PERIODO_LABELS).map(value => ({
        value,
        text: ENVIO_CONTABILIDADE_PERIODO_LABELS[value],
      }));
    },
    spedFiscalSelecionado() {
      return Boolean(this.form.itens && this.form.itens.sped_fiscal);
    },
    perfilSpedOptions() {
      const spedFiscal = this.itens.find(item => item.key === "sped_fiscal");
      const options =
        spedFiscal &&
        spedFiscal.configuration &&
        Array.isArray(spedFiscal.configuration.options)
          ? spedFiscal.configuration.options
          : [];

      if (options.length > 0) {
        return options.map(option => ({
          value: option.value,
          text: option.label,
        }));
      }

      return ["A", "B", "C"].map(value => ({
        value,
        text: `Perfil ${value}`,
      }));
    },
  },
  watch: {
    show(value) {
      if (value) {
        this.resetar();
      }
    },
    value: {
      handler() {
        if (this.show) {
          this.resetar();
        }
      },
      deep: true,
    },
  },
  methods: {
    novoForm() {
      return {
        ...ENVIO_CONTABILIDADE_DEFAULT_FORM,
        emails: [],
        cc: [],
        bcc: [],
        itens: {},
      };
    },
    resetar() {
      const base = this.value ? { ...this.value } : this.novoForm();
      this.form = {
        ...this.novoForm(),
        ...base,
        emails: [...(base.emails || [])],
        cc: [...(base.cc || [])],
        bcc: [...(base.bcc || [])],
        horario: "07:00",
        itens: this.normalizarItens(base.itens || {}),
        perfil_sped: base.perfil_sped || "B",
      };
      this.errors = {};
    },
    normalizarItens(itensSelecionados) {
      const itens = {};

      this.itens.forEach(item => {
        itens[item.key] = Boolean(itensSelecionados[item.key]);
      });

      Object.keys(itensSelecionados || {}).forEach(key => {
        if (!Object.prototype.hasOwnProperty.call(itens, key)) {
          itens[key] = Boolean(itensSelecionados[key]);
        }
      });

      return itens;
    },
    state(field) {
      if (!Object.prototype.hasOwnProperty.call(this.errors, field)) {
        return null;
      }

      return false;
    },
    validarEmails(field, required = false) {
      const emails = this.form[field] || [];

      if (required && emails.length === 0) {
        return "Informe ao menos um destinatário válido.";
      }

      const invalido = emails.find(email => !EMAIL_REGEX.test(email));

      if (invalido) {
        return "Informe um e-mail válido.";
      }

      return "";
    },
    validar() {
      const errors = {};
      const diaMes = Number(this.form.dia_mes);

      if (!this.form.nome) {
        errors.nome = "Informe o nome da rotina.";
      }

      const emailsError = this.validarEmails("emails", true);
      if (emailsError) {
        errors.emails = emailsError;
      }

      const ccError = this.validarEmails("cc");
      if (ccError) {
        errors.cc = "Informe um e-mail válido para cópia.";
      }

      const bccError = this.validarEmails("bcc");
      if (bccError) {
        errors.bcc = "Informe um e-mail válido para cópia oculta.";
      }

      if (!diaMes || diaMes < 1 || diaMes > 31) {
        errors.dia_mes = "O dia do mês deve ser entre 1 e 31.";
      }

      if (!this.form.periodo) {
        errors.periodo = "Informe o período da competência.";
      }

      const possuiItem = Object.keys(this.form.itens || {}).some(
        key => this.form.itens[key]
      );

      if (!possuiItem) {
        errors.itens = "Selecione pelo menos um item para envio.";
      }

      if (
        this.spedFiscalSelecionado &&
        !["A", "B", "C"].includes(this.form.perfil_sped)
      ) {
        errors.perfil_sped = "Selecione o perfil do SPED Fiscal.";
      }

      this.errors = errors;

      return Object.keys(errors).length === 0;
    },
    salvar() {
      if (!this.validar()) {
        return;
      }

      this.$emit("save", {
        ...this.form,
        dia_mes: Number(this.form.dia_mes),
        horario: "07:00",
      });
    },
  },
};
</script>
